import clsx from "clsx";

import type { LadderTierKey } from "../types";

import { Typo } from "../../Typo";
import { TierBadgeImage } from "./TierBadgeImage";

type TierBadgeProps = {
  tierKey: LadderTierKey | null;
  tierName: string;
};

export const TierBadge = ({ tierKey, tierName }: TierBadgeProps) => {
  const sizeClass = clsx("lg:h-12 lg:w-12", "h-8 w-8");

  return (
    <div className="flex items-center gap-1 lg:gap-2">
      <TierBadgeImage
        tierKey={tierKey}
        className={clsx("shrink-0 object-contain", sizeClass)}
      />
      <Typo
        element="span"
        smType="labelMD"
        lgType="labelXL"
        textColor="text-text-primary"
      >
        {tierName}
      </Typo>
    </div>
  );
};
